import { render, staticRenderFns } from "./MasterPenggunaTurunan.vue?vue&type=template&id=fcdc6336&"
import script from "./MasterPenggunaTurunan.vue?vue&type=script&lang=js&"
export * from "./MasterPenggunaTurunan.vue?vue&type=script&lang=js&"
import style0 from "./MasterPenggunaTurunan.vue?vue&type=style&index=0&id=fcdc6336&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports